var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid font-family-avenir-bold" }, [
    _c(
      "div",
      { attrs: { id: "carousel-widget-slide" } },
      [
        _c(
          "VueSlickCarousel",
          _vm._b(
            {
              scopedSlots: _vm._u([
                {
                  key: "nextArrow",
                  fn: function() {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "custom-arrow-next",
                          attrs: { type: "button" }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-chevron-right"
                          })
                        ]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "prevArrow",
                  fn: function() {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "custom-arrow-prev",
                          attrs: { type: "button" }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-chevron-left"
                          })
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            "VueSlickCarousel",
            _vm.settings,
            false
          ),
          [
            _vm._v(" "),
            _vm._v(" "),
            _vm._l(_vm.imageData, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "text-center image-caption" },
                [
                  item.image
                    ? _c("img", {
                        staticClass: "widget-img-view",
                        attrs: {
                          src: _vm.resolveImageUrl(item.image),
                          alt: "img"
                        },
                        on: { error: _vm.handleImageError }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.url
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "font-size-18 text-decoration-none text-reset",
                          attrs: {
                            href: item.url,
                            target:
                              item.openInNewTab == true ? "_blank" : "_self"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.title) + "\n          "
                          ),
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-chevron-right"
                          })
                        ]
                      )
                    : _vm._e()
                ]
              )
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }